import { render, staticRenderFns } from "./GroupsView.vue?vue&type=template&id=4db59e4c&scoped=true"
import script from "./GroupsView.vue?vue&type=script&lang=ts"
export * from "./GroupsView.vue?vue&type=script&lang=ts"
import style0 from "./GroupsView.vue?vue&type=style&index=0&id=4db59e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db59e4c",
  null
  
)

export default component.exports